import React from 'react';
import './styles.scss';
import Button from '../../../components/molecules/buttons';
import { User } from '../../../components/atoms/icons';
import useUsers from './hooks';
import Stepper from '../../../components/molecules/steppers';
import RenderUserList from './RenderUserList';
import LandingHeader from '../../../components/layout/header/landing';

function UserManagement(): React.ReactElement {
  const {
    step, setStep, navigateToAddUser, listUser, userListLoad,
    navigateToDetailActive, navigateToDetailDeleted,
  } = useUsers();

  return (
    <div className="py-4">
      <LandingHeader title="User Management" />
      <div className="px-4 px-xl-5">
        <div className="row">
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Stepper.Slide labels={['Active', 'Deleted']} step={step} setStep={setStep} />
          </div>
          <div className={step === 0 ? 'col-xl-2 col-lg-2 col-md-3 offset-md-3 offset-lg-6 offset-xl-7 mb-4 mb-lg-0 col-sm-12' : 'd-none'}>
            <Button.Default id="addUser" type="button" label="Add User" onClick={navigateToAddUser} />
          </div>
        </div>
        <div className="w-100">
          <RenderUserList
            listUser={listUser}
            isLoading={userListLoad}
            onNavigate={step === 0 ? navigateToDetailActive : navigateToDetailDeleted}
            step={step}
          />
        </div>
      </div>
    </div>
  );
}

export default UserManagement;
